import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import store from '../store/configureStore';

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (page) => {
    let auth = store.getState().auth;
    let membership_level = 'guest';
    if (auth && auth.user != null) {
      membership_level = 'member';
    }
    TagManager.dataLayer({
      dataLayer: {
        event: 'page_view',
        page: page,
        membership_level: membership_level,
        ...options,
      },
    });
  };

  const HOC = (props) => {
    useEffect(
      () => trackPage(props.location.pathname),
      [props.location.pathname]
    );

    return <WrappedComponent {...props} />;
  };

  return HOC;
};
export default withTracker;



// WEBPACK FOOTER //
// ./src/modules/withTracker.js